"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetName = void 0;

/**
 * Список виджетов
 */
var WidgetName;
exports.WidgetName = WidgetName;

(function (WidgetName) {
  WidgetName["SEARCHER"] = "SEARCHER";
  WidgetName["DIRECTION"] = "DIRECTION";
  WidgetName["METAREGIONS"] = "METAREGIONS";
  WidgetName["HOTEL"] = "HOTEL";
  WidgetName["PACKAGE"] = "PACKAGE";
  WidgetName["CIGARETTE"] = "CIGARETTE";
  WidgetName["SEARCH"] = "SEARCH";
})(WidgetName || (exports.WidgetName = WidgetName = {}));